<div
  #inputWrapper
  [formGroup]="form"
  class="wrapper"
  [ngClass]="[getFormClasses(), size]"
>
  <input
    #input
    [ariaLabel]="ariaLabel ?? label"
    [attr.enterkeyhint]="enterkeyhint"
    class="input"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [name]="name"
    [placeholder]="formStates.labelRaised ? placeholder : ''"
    [type]="passwordVisible ? 'text' : type"
    (keydown.tab)="noTab ? disableTab($event) : null"
    (keydown.enter)="onEnterPressed($event)"
    (keydown)="onKeyDown($event)"
    [readOnly]="readonly"
    [pattern]="pattern"
    [disabled]="disabled"
    [tabindex]="disabled ? -1 : tabIndex"
    [required]="required"
    formControlName="formValue"
    [mention]="mentionItems"
    (itemSelected)="onMentionSelect($event)"
    (searchTerm)="mentionInputHandler($event)"
    (closed)="onMentionClosed()"
  />
  <div class="notch">
    <div class="lead"></div>
    <div class="main">
      <label class="lines-{{ labelLines }}">{{ label }}</label>
    </div>
    <div class="trail"></div>
  </div>
  <div class="icon" *ngIf="!hideIcons">
    <ark-icon
      *ngIf="!actionIcon && displayIcon === 'lock'"
      [icon]="'system-lock'"
      size="medium"
      [staticStroke]="true"
      [ngxTippy]="toolTip"
      [tippyProps]="{ arrow: true, placement: 'right' }"
      color="inactive"
    ></ark-icon>
    <!-- <ark-icon
      *ngIf="!actionIcon && displayIcon === 'tick'"
      icon="system-tick"
      size="medium"
      [staticStroke]="true"
      color="cta"
    ></ark-icon> -->
    <ark-icon
      *ngIf="actionIcon && formFilled"
      [icon]="actionIcon"
      size="medium"
      [staticStroke]="true"
      color="cta"
      (click)="actionIconClick()"
    ></ark-icon>
    <ark-icon
      *ngIf="!actionIcon && displayIcon === 'clear'"
      icon="system-close"
      size="tiny"
      color="inactive"
      (mousedown)="clear($event)"
    ></ark-icon>
    <ark-icon
      *ngIf="!actionIcon && displayIcon === 'eye'"
      (mousedown)="togglePasswordVisibility($event)"
      [icon]="
        passwordVisible ? 'system-visibility-on' : 'system-visibility-off'
      "
      size="medium"
      [staticStroke]="true"
      [color]="passwordVisible ? 'cta' : 'disabled'"
    ></ark-icon>
    <ark-icon
      *ngIf="!actionIcon && rightIcon === 'alert-information' && !_value"
      ngxTippy
      [tippyName]="tippyName"
      [attr.data-tippy-content]="toolTip"
      [tippyProps]="toolOptions"
      icon="alert-information"
      size="small"
      color="darkTint"
    ></ark-icon>
    <div class="verifying" *ngIf="verifying">
      <ark-spinner></ark-spinner>
    </div>
  </div>
</div>
<div class="error error-bottom" *ngIf="formStates.error" [@dropdownAnimation]>
  <span>{{ errorMessage }}</span>

  <div
    *ngIf="
      type === 'password' && passwordValidate && form.get('formValue')?.dirty
    "
  >
    <span
      class="block opacity-50 text-green-500"
      [class.!opacity-100]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['upper']
      "
      [class.!text-red-400]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['upper']
      "
      >At least one uppercase letter.</span
    >
    <span
      class="block opacity-50 text-green-500"
      [class.!opacity-100]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['lower']
      "
      [class.!text-red-400]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['lower']
      "
      >At least one lowercase letter.</span
    >
    <span
      class="block opacity-50 text-green-500"
      [class.!opacity-100]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['number']
      "
      [class.!text-red-400]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['number']
      "
      >At least one digit.</span
    >
    <span
      class="block opacity-50 text-green-500"
      [class.!opacity-100]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['special']
      "
      [class.!text-red-400]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['special']
      "
      >At least one special character.</span
    >
    <span
      class="block opacity-50 text-green-500"
      [class.!opacity-100]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['min']
      "
      [class.!text-red-400]="
        form.controls['formValue'].errors &&
        form.controls['formValue'].errors['min']
      "
      >At least 8 characters long.</span
    >
  </div>
</div>
<div class="info" *ngIf="info">
  <span>{{ info }}</span>
</div>
